import { render } from "./success-message.vue?vue&type=template&id=fb3cabfa&scoped=true"
import script from "./success-message.vue?vue&type=script&lang=js"
export * from "./success-message.vue?vue&type=script&lang=js"

import "./success-message.vue?vue&type=style&index=0&id=fb3cabfa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb3cabfa"]])

export default __exports__